(function(){
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Reveal on scroll (IntersectionObserver)
  function initReveals(root=document){
    if(prefersReduced) {
      root.querySelectorAll('.ttc-reveal').forEach(el=>el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        if(e.isIntersecting){
          const el = e.target;
          // optional per-element delay
          const d = el.getAttribute('data-delay');
          if(d) el.style.setProperty('--ttc-delay', d);
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    root.querySelectorAll('.ttc-reveal').forEach(el=>io.observe(el));
  }

  // ---- Subtle parallax (translateY)
  // data-parallax="0.08" (speed), reasonable range: 0.04–0.18
  const parallaxes = [];
  let rafId = null;
  function collectParallax(root=document){
    root.querySelectorAll('[data-parallax]').forEach(el=>{
      const speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
      parallaxes.push({ el, speed, y:0, ty:0 });
    });
  }
  function onScroll(){
    if(prefersReduced || !parallaxes.length) return;
    if(rafId) return;
    rafId = requestAnimationFrame(tick);
  }
  function tick(){
    rafId = null;
    const vh = window.innerHeight;
    parallaxes.forEach(obj=>{
      const r = obj.el.getBoundingClientRect();
      // progress from -vh..vh around viewport center -> -1..1
      const mid = r.top + r.height/2 - vh/2;
      const p = Math.max(-1, Math.min(1, mid / (vh/2)));
      const target = p * 100 * obj.speed; // px shift
      // lerp for buttery motion
      obj.y = obj.y + (target - obj.y) * 0.12;
      obj.el.style.transform = `translate3d(0, ${obj.y.toFixed(2)}px, 0)`;
    });
  }

  function init(root=document){
    initReveals(root);
    collectParallax(root);
    onScroll(); // run once
  }

  // Kickoff
  document.addEventListener('DOMContentLoaded', ()=> {
    init(document);
    if(!prefersReduced){
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onScroll);
    }
  });

  // Re-init inside Shopify Theme Editor
  document.addEventListener('shopify:section:load', e=>init(e.target));
  document.addEventListener('shopify:section:unload', ()=>{ /* no-op */ });

  // Optional: smoothen wheel deltas (tiny)
  // Keep native scroll; we only render transforms.
})();
